<template>
  <div :class="$style.progressBar">
    <span :class="$style.currentTime">{{ currentTime | format }}</span>
    <VueSlider
      v-model="percent"
      tooltip="none"
      :max="1"
      :interval="0.01"
      :height="3"
      :dotSize="15"
      :duration="0"
      :class="$style.progress" />
    <span :class="$style.totalTime">{{ duration | format }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import format from 'format-duration'
import VueSlider from 'vue-slider-component'
import './css/slider.css'

export default {
  name: 'ProgressBar',
  components: { VueSlider },
  computed: {
    ...mapState(['duration', 'currentTime']),
    percent: {
      get () {
        let percent = this.currentTime / this.duration || 0
        if (percent >= 1) percent = 1
        return percent
      },
      set (newValue) {
        this.$emit('onSeek', newValue * this.duration)
      }
    }
  },
  filters: {
    format (val) {
      return format(val * 1000)
    }
  }
}
</script>

<style lang="scss" module>
.progressBar {
  display: flex;
  align-items: center;
}

.progress {
  flex: 1;
  margin: 0 12px;
}

.totalTime,
.currentTime {
  flex-shrink: 0;
  font-size: 12px;
  color: #AEB5C0;
  position: relative;
  top: -1px;
}
</style>
